// CSS
import './App.css';
// React Components
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Landing Pages
import LandingNew from './pages/LandingNew/LandingNew.js';                        // NEW Landing page (live)
import Library from './pages/Library/Library.js';                                 // NEW Library page [lists available dbs] (live)
import PricingNew from './pages/PricingNew/PricingNew.js';                        // NEW Pricing page (live)
import ContactNew from './pages/ContactNew/ContactNew.js';                        // NEW Contact page (live)
import TermsOfServiceNew from './pages/TermsOfServiceNew/TermsOfServiceNew.js';   // NEW Terms-of-Service page (live)
import PrivacyPolicyNew from './pages/PrivacyPolicyNew/PrivacyPolicyNew.js';      // NEW Privacy-Policy page (live)
// User Authentication
import CreateAccount from './pages/CreateAccount/CreateAccount.js';               // Create-account page (live)
import Login from './pages/Login/Login.js';                                       // Login page (live)
// Product Pages
import Search from './pages/Search/Search.js';                                    // Search page (live)
import Results from './pages/Results/Results.js';                                 // Results page (live)
import History from './pages/History/History.js';                                 // History page (live)
import Directory from './pages/Directory/Directory.js';                           // Directory page (live)
import DatabaseNew from './pages/DatabaseNew/DatabaseNew.js';                     // DatabaseNew page (live)
import Bookmarks from './pages/Bookmarks/Bookmarks.js';                           // Bookmarks (live)
import Cache from './pages/Cache/Cache.js';                                       // Cache (live)
// Helper Components
import ScrollToTop from './components/ScrollToTop/ScrollToTop.js';                // automatically scroll user to top of screen (live)


// Function Component.
function App() {
  return (
    <Router>
      <ScrollToTop/> {/* scroll user to top of screen */}

      <Routes>
        {/* LANDING PAGES */}
        <Route path='/' element={< LandingNew />} />
        <Route path='/library' element={< Library />} />
        <Route path='/pricing' element={ < PricingNew /> }/>
        <Route path='/contact' element={ < ContactNew /> }/>
        
        {/* LEGAL PAGES */}
        <Route path='/privacy' element={ < PrivacyPolicyNew/> }/>
        <Route path='/terms' element={ <TermsOfServiceNew/> }/>
        
        {/* USER JOURNEY */}
        <Route path='/create-account/*' element={ < CreateAccount /> }/>
        <Route path='/login/*' element={ < Login /> }/>

        {/* PRODUCT PAGES */}
        <Route path='/search' element={ < Search /> } />
        <Route path='/results' element={ <Results /> } />
        <Route path='/history' element={ <History/> } />
        <Route path='/directory' element={ <Directory/> } />
        <Route path='/db' element={ <DatabaseNew/> } />
        <Route path='/bookmarks' element={ <Bookmarks/> } />
        <Route path='/cache' element={ <Cache/> } />
      </Routes>
    </Router>
  );
}

// Export Component.
export default App;
